// dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../../../../../../../src/lib/component-base';
// children
import AirlinesSelect from './children/AirlinesSelect';
import QuerySelector from './children/QuerySelector';

@componentBase('AirlineSelections')
export default class AirlineSelections extends Component {
  static propTypes = {
    airlines: PropTypes.array,
    dispatch: PropTypes.func,
    includeCodeshares: PropTypes.bool,
    includeCargo: PropTypes.bool,
    inputObjectDefaults: PropTypes.object,
  };

  render() {
    const { airlines, dispatch } = this.props;
    return (
      <div className='data-export-info-container-airline'>
        <div className='row'>
          <div className='col-xs-12 col-sm-5'>
            <AirlinesSelect
              airlines={airlines}
              dispatch={dispatch}
            />
          </div>
          <div className='col-xs-12 col-sm-offset-1 col-sm-6 col-md-5'>
            <div className='query-selector-group'>
              <QuerySelector
                includeCodeshares={this.props.includeCodeshares}
                includeCargo={this.props.includeCargo}
                inputObjectDefaults={this.props.inputObjectDefaults}
              />
            </div>
          </div>
        </div>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/ExportsSearch/children/CompileDataForm/children/AirlineSelections/AirlineSelections.js